'use strict';

import React from 'react';

require('styles/search/Product.css');

let getFPVLogo = require('../../images/getfpv.png');
let hobbykingLogo = require('../../images/hobbyking.png');
let foxtechfpvLogo = require('../../images/foxtechfpv.png');
let multirotorsuperstoreLogo = require('../../images/multirotorsuperstore.png');
let readymadercLogo = require('../../images/readymaderc.png');
let rotorgeeksLogo = require('../../images/rotorgeeks.png');
let banggoodLogo = require('../../images/banggood.png');

class ProductComponent extends React.Component {
  constructor(props) {
      super(props);
      this.clickedLink = this.clickedLink.bind(this);
  }

  clickedLink(event) {
    this.props.onClickProduct(this.props.product.link);
  }

  render() {
    var colStyle = {
    }
    var panelStyle = {
      'borderRadius':'0px',
      'textAlign':'center'
    }
    var imageStyle = {
      width:"100%",
      float:'left',
      position:'relative'
    }

    var logoStyle = {
      width:"75px"
    }

    var priceStyle = {
      'marginBottom':'0px'
    }

    var logo_location = ""
    if (this.props.product.store == "getfpv") {
      logo_location = getFPVLogo;
    } else if (this.props.product.store == "hobby_king") {
      logo_location = hobbykingLogo;
    } else if (this.props.product.store == "foxtechfpv") {
      logo_location = foxtechfpvLogo;
    } else if (this.props.product.store == "multirotorsuperstore") {
      logo_location = multirotorsuperstoreLogo;
    } else if (this.props.product.store == 'readymaderc') {
      logo_location = readymadercLogo;
    } else if (this.props.product.store == 'rotorgeeks') {
      logo_location = rotorgeeksLogo;
    } else if (this.props.product.store == 'banggood') {
      logo_location = banggoodLogo;
    }

    var panel_body = <div className="panel-body"></div>
    if (this.props.product.images && this.props.product.images.length > 0) {
      var thumb_location = this.props.product.images[0]['path'].replace("full/","thumbs/big/");
      var image_location = "https://metadroner-data.s3.amazonaws.com/scraping/images/" + thumb_location;
      panel_body = (
        <div className="panel-body">
          <img src={image_location} style={imageStyle}></img>
        </div>
      );
    }

    var buyBtn = <a className="btn btn-primary btn-lg" href={this.props.product.link} target="_blank" onClick={this.clickedLink}>Buy it now</a>
    if (this.props.product.in_stock == false) {
      buyBtn = (<a className="btn btn-danger btn-lg" href={this.props.product.link} target="_blank" onClick={this.clickedLink}>View Product <br></br><small>Out of stock</small> </a>)
    }

    return (
      <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2" style={colStyle}>
        <div className="panel panel-default" style={panelStyle}>
          <div className="panel-heading">
            <h3 className="panel-title">{this.props.product.title}</h3>
          </div>
          {panel_body}
          <div className="panel-footer">
            <p className="lead" style={priceStyle}> ${this.props.product.price} at <img src={logo_location} style={logoStyle}/></p>
            <br></br>
            {buyBtn}
          </div>
        </div>
      </div>
    );
  }
}

ProductComponent.displayName = 'SearchProductComponent';

// Uncomment properties you need
// ProductComponent.propTypes = {};
// ProductComponent.defaultProps = {};

export default ProductComponent;



/** WEBPACK FOOTER **
 ** ./src/components/search/ProductComponent.js
 **/